export enum ComputeFormat {
  None = 0,
  Period = 1,
  DateTime = 2,
  Numeric = 3,
}
